
export const getPropsByEquipmentType = /* GraphQL */ `
  query PropertiesSearch($filter: SearchablePropertyMetadataFilterInput) {
    searchPropertyMetadata(limit: 1000, filter: $filter) {
      items {
        tisDisplayName
        targetKey
        id
        equipmentType
        targetMeasureUnit
        targetMeasureType
        targetDataType
        maxValue
        minValue
      }
      total
    }
  }
`



export const getEquipmentTypes = `query PropertiesSearch($filter: SearchablePropertyMetadataFilterInput) {
  searchPropertyMetadata(limit: 1000, filter: $filter) {
    items {
      equipmentType
    }
    total
  }
}
`


export const createAnomalyRule = `
mutation CreateAnomalyRule($input: CreateAnomalyDetectionRulesInput!) {
  createAnomalyDetectionRules(input: $input){
    id
    name
  }
}
`


export const updateAnomalyRule = `
mutation UpdateAnomalyRule($input: UpdateAnomalyDetectionRulesInput!) {
  updateAnomalyDetectionRules(input: $input){
    id
    name
  }
}
`




export const listAnomaliesRules = `
query ListAnomaliesRules($filter: ModelAnomalyDetectionRulesFilterInput) {
  listAnomalyDetectionRules(filter: $filter, limit: 1000) {
    items {
      conditionData
      createdAt
      createdBy
      description
      equipmentType
      id
      isActive
      layout
      name
      ruleText
      ruleType
      severity
      updatedAt
      updatedBy
    }
  }
}
`


// export const searchAnomaliesResults = `
// query SearchAnomalyDetectionResults($filter: SearchableAnomalyDetectionResultsFilterInput, $nextToken: String) {
//   searchAnomalyDetectionResults(filter: $filter, limit: 1000,  nextToken: $nextToken) {
//     items {
//           accountName
//           accountId
//           buildingId
//           buildingName
//           detectedForDate
//           equipmentId
//           equipmentName
//           equipmentType
//           id
//           ruleId
//           ruleName
//           ruleText
//           ruleType
//           severity
//           resultsData
//           createdAt
//     }
//     nextToken
//   }
// }
// `


export const searchAnomaliesResults = `
query ListAnomalyDetectionResults($filter: ModelAnomalyDetectionResultsFilterInput, $nextToken: String) {
  listAnomalyDetectionResults(filter: $filter, limit: 1000,  nextToken: $nextToken) {
    items {
          accountName
          accountId
          salesOfficeId
          buildingId
          buildingName
          detectedForDate
          equipmentId
          equipmentName
          equipmentType
          id
          status
          ruleId
          ruleName
          ruleText
          ruleType
          severity
          resultsData
          createdAt

    }
    nextToken
  }
}
`


export const SEARCH_BUILDINGS = /* GraphQL */ `
  query SearchBuildings(
    $filter: SearchableBuildingFilterInput
    $sort: [SearchableBuildingSortInput]
  ) {
    searchBuildings(filter: $filter, sort: $sort, limit: 40) {
      items {
        name
        id
        isActive
        accountName
      }
    }
  }
`

export const runRuleOnDemand = `
mutation InitiateAnomalyDetection($body: AWSJSON!) {
  initiateAnomalyDetection(body: $body) 
}
`

export const getAnomalyRulesProperties = `
query GetAnomalyRulesProperties($body: AWSJSON!) {
  getAnomalyRulesProperties(body: $body) 
}
`

export const deleteAnomalyRule = `
mutation DeleteAnomalyRule($input: DeleteAnomalyDetectionRulesInput!) {
  deleteAnomalyDetectionRules(input: $input){
    id
    name
  }
}
`

export const CreateAnomalyDetectionRulesMapping = `
mutation CreateAnomalyDetectionRulesMapping($input: CreateAnomalyDetectionRulesMappingInput!) {
  createAnomalyDetectionRulesMapping(input: $input){
    id
    ruleName
  }
}
`

export const UpdateAnomalyDetectionRulesMapping = `
mutation UpdateAnomalyDetectionRulesMapping($input: UpdateAnomalyDetectionRulesMappingInput!) {
  updateAnomalyDetectionRulesMapping(input: $input){
    id
    ruleName
  }
}
`

export const UpdateAnomalyDetectionResults = `
mutation UpdateAnomalyDetectionResults($input: UpdateAnomalyDetectionResultsInput!) {
  updateAnomalyDetectionResults(input: $input){
    id
    ruleName
    ruleId
  }
}
`

export const DeleteAnomalyDetectionRulesMapping = `
mutation DeleteAnomalyDetectionRulesMapping($input: DeleteAnomalyDetectionRulesMappingInput!) {
  deleteAnomalyDetectionRulesMapping(input: $input){
    id
  }
}
`

export const ListAnomalyDetectionRulesMappings = /* GraphQL */ `
  query listAnomalyDetectionRulesMappings($filter: ModelAnomalyDetectionRulesMappingFilterInput!, $nextToken: String) {
  listAnomalyDetectionRulesMappings(filter: $filter, nextToken: $nextToken) {
       items {
      accountId
      buildingId
      conditionData
      description
      equipmentId
      equipmentType
      id
      isActive
      ruleId
      ruleName
      ruleType
      severity
      createdBy
    }
    nextToken
  }
}
`


export const getPropertiesAndSymbols = `query configByTypeAndSubtype($nextToken: String) {
  configByTypeAndSubtype(type: "Dimension", nextToken: $nextToken, limit: 5000) {
    items {
      name
      type
      value
      subType
    }
    nextToken
  }
}
`

